import { DemographicValueModel } from '../demographics/demographic-value-model';
import { SurveyUserDetailsModel } from '../survey/survey-user-details-model';

export interface UserProfileModel {
  userDetails: SurveyUserDetailsModel;
  userDemographicValues: DemographicValueModel[];
}
